import { useAppSelector } from 'universal-scripts';
import './ErrorStep.css';

interface ErrorStepProps {
	errorMessage?: string;
}

export default function ErrorStep({ errorMessage }: ErrorStepProps) {
	const storeError = useAppSelector((state) => state.sentinel.error);
	const currentPhase = useAppSelector((state) => state.sentinel.currentPhase);

	const displayError = errorMessage || storeError || (currentPhase ? `Error during ${currentPhase} phase` : 'An unexpected error occurred');

	return (
		<div className="sentinel-step error-step" role="alert">
			<em className="error-message">{displayError}</em>
		</div>
	);
}
